/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-shadow
export var I18nLangs;
(function (I18nLangs) {
    I18nLangs["CS"] = "CS";
    I18nLangs["DE"] = "DE";
    I18nLangs["EN"] = "EN";
    I18nLangs["ES"] = "ES";
    I18nLangs["FR"] = "FR";
    I18nLangs["IT"] = "IT";
    I18nLangs["PL"] = "PL";
    I18nLangs["PT"] = "PT";
    I18nLangs["SK"] = "SK";
    I18nLangs["SL"] = "SL";
    // UK = "UK",
})(I18nLangs || (I18nLangs = {}));
